import { OrganizationCountry } from "../types/countryRegion";
import { UserPermissions } from "./user";
export const getOrderedProductPermissions = (organizationCountry) => organizationCountry === OrganizationCountry.GreatBritain
    ? [
        UserPermissions.Donation,
        UserPermissions.Ticketing,
        UserPermissions.Contacts,
        UserPermissions.Bank,
        UserPermissions.TapToPay,
    ]
    : [
        UserPermissions.Donation,
        UserPermissions.Ticketing,
        UserPermissions.Contacts,
        UserPermissions.Receipt,
        UserPermissions.Bank,
        UserPermissions.TapToPay,
    ];
export const orderedActionsPermissions = [UserPermissions.UserManagement];
export const getOrderedPermissions = (organizationCountry) => [
    ...getOrderedProductPermissions(organizationCountry),
    ...orderedActionsPermissions,
];
